<template>
  <booking-attendance
    v-if="config"
    :content="data"
    :config="config"
    :locale="locale"
    :isDesktop="false"
  />
</template>

<script>
import { mapState } from 'vuex'
import utils from '@/services/utils'
import api from '@/services/api'
import BookingAttendance from './BookingAttendance'
export default {
  components: {
    BookingAttendance,
  },
  props: {
    data: {
      type: Object,
      required: true,
      default: null,
    },
  },
  data: () => ({
    config: null,
  }),
  computed: {
    ...mapState('app', ['locale', 'FontContent', 'FontSizeContent', 'ColorContent']),
    enterpriseID () {
      return utils.getEnterpiseID()
    },
  },
  mounted () {
    api.getItem('enterprises/config', false, this.enterpriseID)
      .then(response => {
        const aux = JSON.parse(JSON.stringify(response))
        this.config = aux
      })
  }
}
</script>
<style scoped>
</style>

